import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { Link } from 'react-router';
import {
	Panel,
	Row,
	Col,
	Button,
	Tab,
	Nav,
	NavItem,
	Collapse
} from 'react-bootstrap';

import {
	FieldList,
	ClientDetails,
	InfoWidget,
	JobModify,
	FileUploader,
	JobMilestones,
	Pipeline,
	ConfirmationPrompt,
	InteractionsList,
	JobFileUploader
} from 'components';

import * as Actions from 'actions';
import * as Api from 'api';

class JobView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
			pipeline_open : true,
      key : 'Details',
      source_options : []
    };

    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(key) {
    this.setState({key});
  }
  componentWillMount() {
		this.props.fetchPipeline();
		this.props.fetchFields('Client');
		this.props.fetchFields('Job');

    if(this.props.params && this.props.params.job) {
      this.props.fetchJob(this.props.params.job);
      Api.getTypes('job','lead_source').then(source_options => ({source_options}))
    }
  }

	componentWillUpdate(nextProps) {
		if(nextProps.job) {
			if(this.props.job && nextProps.job.client._id == this.props.job.client._id) {
				return;
			}
			this.props.fetchClient(nextProps.job.client._id)
		}
	}
  handleMilestoneChange(job) {
    this.props.sendSocketEmit({ job }, 'update-job');
  }
  render() {
    const { client, job, jobs } = this.props;
		const {pipeline_open} = this.state;
    if(!client || !job) {
      return <noscript />
    }
		if(!job.client) {
			return <div className="alert alert-danger">
				<h1>Sorry</h1>
				<p>No client exists for this opportunity. You may have deleted the client without deleting it's opportunities.</p>
			</div>
		}
    const is_job = job.status == 'Job';
    const bsStyle = is_job ? 'primary' : 'secondary';
		if(jobs.downloading_jobs) {
			return <div className="text-center"><i className="fa fa-spinner fa-spin fa-2x"></i><br /> Loading Jobs...</div>
		}

    return <div className="job-view">
      <Row>
				<Col xs={12} lg={12}>
					<Row>
						<Col xs={12} sm={6} md={6} lg={6}>
		          <InfoWidget bsStyle={bsStyle} icon="fa fa-bullhorn" title={job.status+''} text={'#'+job.number} />
		        </Col>
		        <Col xs={12} sm={6} md={6} lg={6}>
		          <InfoWidget bsStyle={is_job ? 'success' : 'warning'} icon="fa fa-money" title={is_job ? 'Price' : 'Estimated Price'} text={`$${is_job ? Number(job.price).toLocaleString() : Number(job.estimate).toLocaleString()}`} />
		        </Col>
		        <Col xs={12} sm={6} md={6} lg={6}>
		          <InfoWidget bsStyle={'dark'} icon="fa fa-user" title={'Assigned To'} text={job.assigned_to? `${job.assigned_to.name.first} ${job.assigned_to.name.last}` : 'No one.'} extra={job.assigned_to.role} />
		        </Col>
		        <Col xs={12} sm={6} md={6} lg={6}>
		          <InfoWidget bsStyle={'danger'} icon="fa fa-calendar" title={'Last Updated'} text={moment(job.updated_timestamp).format('MM/DD/YYYY hh:mm')} extra={moment(job.updated_timestamp).fromNow()} />
		        </Col>
						<Col xs={12} lg={12}>
							<Tab.Container id="dashboard" activeKey={this.state.key} onSelect={this.handleSelect} >
								<Row className="clearfix">
									<Col sm={12}>
										<Nav bsStyle="tabs" onSelect={this.selectTab}>
											<NavItem eventKey="Details">
												<i className="fa fa-info"></i> {job.status} Details
											</NavItem>
											<NavItem eventKey="Modify">
												<i className="fa fa-pencil"></i> Modify {job.status}
											</NavItem>
											<NavItem eventKey="Client">
												<i className='fa fa-users' /> Client
											</NavItem>
											<NavItem eventKey="Interaction">
												<i className='fa fa-globe' /> Recent Activity
											</NavItem>
											<NavItem eventKey='Pipeline'>
												<i className='fa fa-calendar-check-o' /> Pipeline
											</NavItem>
											<NavItem eventKey="Images">
												<i className='fa fa-image' /> Upload Images
											</NavItem>
											<NavItem eventKey='Files'>
												<i className='fa fa-file' /> Upload Files
											</NavItem>
										</Nav>
									</Col>
									<Col sm={12}>
										<Tab.Content animation>
											<Tab.Pane eventKey="Details">
												<JobModify readOnly={true} job={this.props.job} />
											</Tab.Pane>
											<Tab.Pane eventKey="Modify">
												<JobModify
													job={this.props.job}
													onSave={e => this.handleSelect('Details')}
												/>
											</Tab.Pane>
											<Tab.Pane eventKey="Interaction">
												<InteractionsList enableCreate />
											</Tab.Pane>
											<Tab.Pane eventKey="Client">
												<ClientDetails client={this.props.job.client} simple={true}>
													<Link to={`client/${this.props.job.client._id}`} className="mt-sm btn btn-primary btn-block">View Client</Link>
												</ClientDetails>
											</Tab.Pane>
											<Tab.Pane eventKey='Pipeline'>
												<Pipeline
													pipeline={this.props.pipeline.pipeline}
													job={job}
													client={client}
												/>
											</Tab.Pane>
											<Tab.Pane eventKey='Images'>
												<Row>
													<Col md={6} xs={12}>
														<JobFileUploader
															job={this.props.job}
															endpoint={`/upload/job/${this.props.job._id}/before_picture`}
															title='Before Picture'
															iconFiletypes={[ '.jpg', '.png' ]}
															acceptedFiles={['image/*'].join(',')}
															maxFiles={1}
															preview={job.before_picture ? (
										          	<img src={`${job.before_picture.url}`} className="img-responsive" />
										          ) : (
																<div className="well well-lg"><p className="text-center">None uploaded.</p></div>
															)}
														/>
													</Col>
													<Col md={6} xs={12}>
														<JobFileUploader
															job={this.props.job}
															endpoint={`/upload/job/${this.props.job._id}/after_picture`}
															title='After Picture'
															iconFiletypes={[ '.jpg', '.png' ]}
															acceptedFiles={['image/*'].join(',')}
															maxFiles={1}
															preview={job.after_picture ? (
									              <img src={`${job.after_picture.url}`} className="img-responsive" />
									            ) : (
																<div className="well well-lg"><p className="text-center">None uploaded.</p></div>
															)}
														/>
													</Col>
												</Row>
											</Tab.Pane>
											<Tab.Pane eventKey='Files'>
												<JobFileUploader
													job={this.props.job}
													endpoint={`/upload/job/${job._id}/files`}
													title='After Picture'
													iconFiletypes={[ '.jpg', '.png','.pdf','.xls','.xlsx' ]}
													preview={job.files ? (
														<Row>
															{job.files.filter(file => typeof file !== 'string').map( file => {
																const names = file.filename.split('.');
																const extension = names[names.length-1];
																return (
																	<Col xs={3} md={3}>
																		<p><a target='_blank' href={`${file.url}`}>
																			<i className={`pull-left fa fa-file fa-file-${extension}-o fa-4x`}></i> {file.originalName}
																		</a></p>
																	</Col>
																)
															})}
														</Row>
													) : (
														<div className="well well-lg"><p className="text-center">None uploaded.</p></div>
													)}
												/>
											</Tab.Pane>
										</Tab.Content>
									</Col>
								</Row>
							</Tab.Container>
		        </Col>
					</Row>
					<Row>
						<Col xs={12} lg={12}>
							<div
								className='btn btn-block btn-danger'
								onClick={() => {this.props.toggleShowDeleteJobConfirm(true)}}
								>
								Delete Oppotunity
							</div>
						</Col>
					</Row>
				</Col>
      </Row>
      {job.milestone != 'Cancelled' ? (
        <div>
					{(() => {
						if(this.props.jobs.show_delete_job_confirm) {
							return (
								<ConfirmationPrompt
									handleCancelPrompt={() => {this.props.toggleShowDeleteJobConfirm(false)}}
									handleConfirmPrompt={() => {this.props.deleteJob(this.props.jobs.previewing_job)}}
									type='danger'
									title='Delete Opportunity?'
									body='Are you sure you want to delete this opportunity? This cannot be undone'
									show_condition={this.props.jobs.show_delete_job_confirm}
									confirm_button_text='Delete'
									bsSize='small'
								/>
							)
						}
					})()}
        </div>
      ) : ''}
    </div>
  }
}

///passes job_container props as props to this component.
const mapStateToProps = ({client, jobs, pipeline}) => ({pipeline, client, jobs});

export default connect(mapStateToProps, Actions)(JobView);



// WEBPACK FOOTER //
// ./src/browser/components/client/jobs/job-view.js